import { $ } from '@/Engine/state';

export const onOrbitControlChangeHandler = ():void => {
    // TODO
    $.render();
};
